import React, { useState, useEffect } from "react";
import logo from "../../assets/logo.png";
import headerImg from "../../assets/images/header-img.jpg";
import axios from "axios";

const Header = () => {
  const [intro, setIntro] = useState([]);
  const [header, setHeader] = useState([]);

  const showNavbar = () => {
    const menu = document.querySelector("#menu");
    menu.classList.toggle("hidden");
  };

  useEffect(() => {
    getIntroCaption();
    getHeader();
  }, []);

  const getHeader = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}header`
        // `http://localhost:5000/header`
      );
      setHeader(response.data.header);
    } catch (error) {
      console.log(error);
    }
  };

  const getIntroCaption = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}introCaption`
      );
      // console.log(response);
      setIntro(response.data.intro);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="flex flex-wrap items-center justify-between w-full pt-4 pb-0 md:py-0 px-4 text-lg text-gray-70 bg-white/70  backdrop-blur-sm  fixed top-0 left-0 right-0 z-50 shadow">
        <div>
          <a href="#" className="font-bold">
            <img src={logo} alt="Anjas-Logo" className="w-14" />
          </a>
        </div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="menu-button"
          className="h-6 w-6 cursor-pointer md:hidden block"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          onClick={() => showNavbar()}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>

        <div
          className="hidden  w-full md:flex md:items-center md:w-auto"
          id="menu"
        >
          <ul
            className="
              pt-0
              text-base text-slate-600
              md:flex
              md:justify-between
              md:flex-row
              md:pt-0
              absolute
              text-center
              md:text-left
              left-0
              w-full
              md:h-auto
              h-screen
              md:relative font-poppins
              md:text-sm  uppercase md:bg-transparent  bg-white/90 flex flex-col justify-center items-center"
          >
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third text-xl md:text-[0.9rem]"
                href="#"
              >
                Beranda
              </a>
            </li>
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third  text-xl md:text-[0.9rem]"
                href="#product"
              >
                Produk
              </a>
            </li>
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third text-xl md:text-[0.9rem]"
                href="#services"
              >
                Pelayanan
              </a>
            </li>
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third  text-xl md:text-[0.9rem]"
                href="#contact"
              >
                Kontak
              </a>
            </li>
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third  text-xl md:text-[0.9rem]"
                href="#about"
              >
                Tentang
              </a>
            </li>
            <li className=" md:border-none tracking-wider">
              <a
                className="md:p-4 py-4 drop-shadow block hover:text-third  text-xl md:text-[0.9rem]"
                href="/login"
              >
                Login
              </a>
            </li>

            {/* <li>
              <a
                className="md:p-4 py-2 block hover:text-purple-400 text-purple-500"
                href="#"
              >
                Sign Up
              </a>
            </li> */}
          </ul>
        </div>
      </nav>
      {/* Hero Image */}
      <section className="container mx-auto mt-10 md:mt-14 overflow-x-hidden">
        <div className="w-full h-screen md:h-[600px] flex justify-center items-center box-border overflow-hidden">
          <div className="w-full md:w-1/2 text-center md:text-left box-border">
            <h2
              className="text-4xl md:text-6xl text-slate-800 font-bold mb-6 font-playfairDisplay"
              data-aos="fade-left"
              data-aos-duration="700"
            >
              <span className="border-t-2 md:border-t-2 border-slate-800">
                ANJAS K
              </span>
              <span className="border-b-2 md:border-b-2 border-slate-800">
                ONVEKSI
              </span>
            </h2>
            <p
              className="text-sm md:text-base px-4 font-poppins text-slate-500 font-light  md:pr-4 md:px-0 leading-relaxed"
              data-aos="fade-right"
              data-aos-duration="700"
            >
              {intro.map((intr) => intr.caption)}
            </p>
            <div
              className="mt-10 text-white"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <a
                href="#services"
                className="border font-poppins  bg-third tracking-wider text-lg px-4 py-3 md:px-10 hover:bg-slate-800 transition duration-200 shadow-md hover:shadow-lg "
              >
                Explore
              </a>
            </div>
          </div>
          <div
            className="hidden md:block md:w-1/2 relative  w-full h-full bg-cover rounded-md overflow-hidden dark-overlay"
            data-aos="fade-left"
            data-aos-duration="600"
          >
            {header.map((head) => (
              <img
                key={head.id}
                src={head.url}
                alt=""
                className="w-full h-full"
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Header;
